module.exports = __webpack_public_path__ + "static/img/exp3.2882b7b9.png";